import { render, staticRenderFns } from "./EnquiryDetail.vue?vue&type=template&id=0da18db6&"
import script from "./EnquiryDetail.vue?vue&type=script&lang=js&"
export * from "./EnquiryDetail.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports